import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/no-empty-function */
import { Vue, Component, Prop, Inject, Ref } from 'vue-property-decorator';
import * as CodeMirror from 'codemirror';
import { codemirror } from 'vue-codemirror';
import { debounce } from "lodash-es";
import { CTRL_KEY_LABEL, INJECT_PROPPANEL_RUNEXPR, INJECT_UICORE_BUS, IS_MAC } from "../../../lib/utils/consts";
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import { ICMBToolbar } from './ICMBToolbar';
import 'codemirror/addon/display/placeholder';
import 'codemirror/addon/hint/show-hint';
import "./style.css";
import { ICMBPopupEditor } from './PopupEditor';
import { ICMBRunExprEditor } from './RunExprEditor';
import { ICMBTButton } from './ICMBTButton';
/**
 * 提供了懒加载、debounce、placeholder 等特殊配置的 CodeMirror 输入框基类
 */
// @ts-ignore
let InlineCodeMirrorBase = class InlineCodeMirrorBase extends Vue {
  constructor() {
    super(...arguments);
    // #endregion
    // --------------------------------------------------------------------
    this.tempValue = '';
    this.isMouseDown = false;
    this.activated = false;
    this.isMouseHovering = false;
    this.icmbPopupShown = false;
    this.icmbRunExprShown = false;
  }
  // #region 所有抽象的东西 -- 实现子组件需要自己补全的
  /** @abstract */
  get cmOptions() {
    return {};
  }
  /** @abstract */
  get toolbar() {
    return [];
  }
  /** @abstract */
  get cmEventListeners() {
    return {};
  }
  /** @abstract */
  get popupTitle() {
    return 'Editor';
  }
  /** @abstract */
  getTextForCm() {
    var _this$value;
    return String((_this$value = this.value) !== null && _this$value !== void 0 ? _this$value : '');
  }
  /** @abstract */
  onCmChange(value) {
    this.$emit('change', value);
  }
  /** @abstract */
  render() {
    const h = arguments[0];
    const baseClass = this.getInlineCodeMirrorBaseClassName();
    return h("div", {
      "class": baseClass
    }, [this.renderInlineCodeMirrorBase()]);
  }
  /** @abstract */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onCmReady(cm) {}
  /** @abstract */
  onBlur() {}
  /** @abstract */
  onFocus() {}
  created() {
    this.commitDebounced = debounce(() => {
      // 此处为空字符串，外面为 null 或者 undefined 的时候不修改
      if (this.tempValue !== this.getTextForCm()) {
        this.onCmChange(this.tempValue);
      }
    }, 300, {
      trailing: true,
      leading: true
    });
    this.showHintDebounced = debounce(() => {
      var _this$cm, _this$cm$showHint;
      (_this$cm = this.cm) === null || _this$cm === void 0 || (_this$cm$showHint = _this$cm.showHint) === null || _this$cm$showHint === void 0 || _this$cm$showHint.call(_this$cm);
    }, 150);
    this.$watch(() => this.getTextForCm(), val => {
      if (this.tempValue !== val) {
        this.tempValue = val;
        this.commitDebounced.cancel();
      }
    }, {
      immediate: true
    });
  }
  mounted() {
    this.unsyncDummyCodeMirrorLine = this.$watch(() => [this.tempValue || '', this.icmbCmOptions.mode], ([v, modeName]) => {
      const target = this.$refs.dummyCodeMirrorLine;
      if (!target) return;
      const mode = CodeMirror.getMode({}, modeName);
      CodeMirror.runMode(v, mode, target);
    }, {
      immediate: true
    });
  }
  beforeDestroy() {
    this.commitDebounced();
    this.commitDebounced.flush();
    this.showHintDebounced.cancel();
  }
  get icmbCmOptions() {
    var _this$uc;
    return {
      theme: 'idea',
      ...((_this$uc = this.uc) === null || _this$uc === void 0 ? void 0 : _this$uc.config.cmOptions),
      autoCloseBrackets: true,
      lineWrapping: true,
      viewportMargin: Infinity,
      readOnly: this.readonly,
      ...this.cmOptions
    };
  }
  icmbOnCmBlur(...args) {
    this.commitDebounced();
    this.commitDebounced.flush();
    this.onBlur();
    this.$emit('blur', args);
  }
  icmbOnCmFocus() {
    this.onFocus();
    this.$emit('focus');
  }
  icmbOnCmReady(cm) {
    this.cm = cm;
    this.$watch(() => this.placeholder, placeholder => cm.setOption('placeholder', placeholder), {
      immediate: true
    });
    const cmWrapper = this.$refs.cmEditor.$el;
    cmWrapper.addEventListener('mousedown', () => {
      if (this.isMouseDown) return;
      this.isMouseDown = true;
      const mouseUpListener = () => {
        this.isMouseDown = false;
        document.body.removeEventListener('mouseup', mouseUpListener, true);
      };
      document.body.addEventListener('mouseup', mouseUpListener, true);
    }, false);
    cm.addKeyMap({
      [`${IS_MAC ? 'Cmd' : 'Ctrl'}-Enter`]: () => {
        var _this$icmbPopupEditor;
        return (_this$icmbPopupEditor = this.icmbPopupEditor) === null || _this$icmbPopupEditor === void 0 ? void 0 : _this$icmbPopupEditor.toggleModal();
      }
    }, true);
    this.onCmReady(cm);
    this.$forceUpdate();
  }
  icmbHandleMouseEnter(ev) {
    var _this$unsyncDummyCode;
    this.isMouseHovering = true;
    const target = ev.target;
    // 避免样式问题，首次渲染 & 尺寸变化要 refresh
    if (this.activated) {
      if (!(target !== null && target !== void 0 && target.getAttribute('data-icmb-marker'))) return;
      const newWidth = target.offsetWidth;
      const newHeight = target.offsetHeight;
      if (!this.icmbLastSize || this.icmbLastSize[0] !== newWidth || this.icmbLastSize[1] !== newHeight) {
        var _this$cm2;
        (_this$cm2 = this.cm) === null || _this$cm2 === void 0 || _this$cm2.refresh();
        this.icmbLastSize = [newWidth, newHeight];
      }
      return;
    }
    this.activated = true;
    (_this$unsyncDummyCode = this.unsyncDummyCodeMirrorLine) === null || _this$unsyncDummyCode === void 0 || _this$unsyncDummyCode.call(this);
  }
  icmbHandleMouseLeave(ev) {
    if (ev.target === ev.currentTarget) {
      this.isMouseHovering = false;
    }
  }
  icmbHandleInput(val) {
    this.tempValue = val;
    if (!this.lazy) this.commitDebounced();
  }
  get icmbNativeOn() {
    return {
      mouseenter: this.icmbHandleMouseEnter,
      mouseleave: this.icmbHandleMouseLeave
    };
  }
  get icmbActualToolbarContent() {
    const h = this.$createElement;
    const runExprButton = this.runExpr && !this.icmbRunExprShown && h(ICMBTButton, {
      "key": "runExpr",
      "attrs": {
        "icon": 'play-circle',
        "title": '试运行'
      },
      "on": {
        "click": this.toggleRunExpr
      }
    });
    if (this.allowPopup && !this.icmbPopupShown) {
      return [h(ICMBTButton, {
        "key": "popupEditor",
        "attrs": {
          "icon": "search-plus",
          "title": `放大编辑区 (${CTRL_KEY_LABEL}-回车)`
        },
        "on": {
          "click": this.togglePopupEditor
        }
      }), runExprButton].filter(Boolean);
    }
    return [].concat(this.toolbar).concat([runExprButton]);
  }
  // --------------------------------------------------------------------
  // 下面是暴露出去给别人用的
  focus() {
    var _this$cm3;
    (_this$cm3 = this.cm) === null || _this$cm3 === void 0 || _this$cm3.focus();
  }
  togglePopupEditor() {
    var _this$icmbPopupEditor2;
    (_this$icmbPopupEditor2 = this.icmbPopupEditor) === null || _this$icmbPopupEditor2 === void 0 || _this$icmbPopupEditor2.toggleModal();
  }
  // @ts-ignore
  getRunExprRes() {
    var _this$runExpr, _this$cmOptions;
    // @ts-ignore
    return (_this$runExpr = this.runExpr) === null || _this$runExpr === void 0 ? void 0 : _this$runExpr.call(this, this.tempValue, (_this$cmOptions = this.cmOptions) === null || _this$cmOptions === void 0 ? void 0 : _this$cmOptions.mode);
  }
  toggleRunExpr() {
    var _this$icmbRunExprEdit;
    (_this$icmbRunExprEdit = this.icmbRunExprEditor) === null || _this$icmbRunExprEdit === void 0 || _this$icmbRunExprEdit.toggleModal();
  }
  getInlineCodeMirrorBaseClassName() {
    return mergeClassName('uc-inputbox ucd-InlineCodeMirrorBase', this.multipleLine && 'isMultipleLine');
  }
  renderInlineCodeMirrorBase(options) {
    const h = this.$createElement;
    if (this.activated) {
      const content = [...((options === null || options === void 0 ? void 0 : options.content) || []), h(codemirror, _mergeJSXProps([{
        "class": "vue-codemirror-edit",
        "ref": "cmEditor",
        "attrs": {
          "options": this.icmbCmOptions,
          "value": this.tempValue,
          "data-icmb-marker": "1"
        },
        "on": {
          "input": this.icmbHandleInput,
          "ready": this.icmbOnCmReady,
          "blur": this.icmbOnCmBlur,
          "focus": this.icmbOnCmFocus
        }
      }, {
        "nativeOn": this.icmbNativeOn
      }]))];
      // 下面是两个弹窗和一个工具栏的逻辑
      if (this.cm) {
        content.push(h(ICMBPopupEditor, {
          "ref": "icmbPopupEditor",
          "attrs": {
            "owner": this
          }
        }));
        this.runExpr && content.push(h(ICMBRunExprEditor, {
          "ref": "icmbRunExprEditor",
          "attrs": {
            "owner": this
          }
        }));
        // 非弹出弹窗状态时 并且启用工具栏 渲染ICMBToolbar
        if (!this.icmbPopupShown && this.allowToolbar) {
          content.push(h(ICMBToolbar, {
            "attrs": {
              "cm": this.cm,
              "autoFold": true,
              "direction": 'column-reverse',
              "multipleLine": !!this.multipleLine,
              "isHidden": !this.isMouseHovering
            }
          }, [this.icmbActualToolbarContent]));
        }
      }
      return content;
    }
    const lineWrapping = !!this.icmbCmOptions.lineWrapping;
    return h("div", _mergeJSXProps2([{
      "class": "vue-codemirror"
    }, {
      "on": this.icmbNativeOn
    }]), [h("div", {
      "class": mergeClassName('CodeMirror', lineWrapping && 'CodeMirror-wrap', this.icmbCmOptions.theme)
    }, [h("div", {
      "class": "CodeMirror-lines",
      "attrs": {
        "role": "presentation"
      }
    }, [!!this.placeholder && !this.tempValue && h("pre", {
      "class": "CodeMirror-placeholder CodeMirror-line-like"
    }, [this.placeholder]), h("pre", {
      "class": "CodeMirror-line",
      "attrs": {
        "role": "presentation"
      },
      "ref": "dummyCodeMirrorLine"
    })])])]);
  }
};
__decorate([Prop({
  required: true
})], InlineCodeMirrorBase.prototype, "value", void 0);
__decorate([Prop({
  type: String,
  default: ''
})], InlineCodeMirrorBase.prototype, "placeholder", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], InlineCodeMirrorBase.prototype, "lazy", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], InlineCodeMirrorBase.prototype, "multipleLine", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], InlineCodeMirrorBase.prototype, "allowPopup", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], InlineCodeMirrorBase.prototype, "allowToolbar", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], InlineCodeMirrorBase.prototype, "readonly", void 0);
__decorate([Inject({
  from: INJECT_UICORE_BUS,
  default: null
})], InlineCodeMirrorBase.prototype, "uc", void 0);
__decorate([Inject({
  from: INJECT_PROPPANEL_RUNEXPR,
  default: null
})], InlineCodeMirrorBase.prototype, "runExpr", void 0);
__decorate([Ref()], InlineCodeMirrorBase.prototype, "icmbPopupEditor", void 0);
__decorate([Ref()], InlineCodeMirrorBase.prototype, "icmbRunExprEditor", void 0);
InlineCodeMirrorBase = __decorate([Component({
  name: 'InlineCodeMirrorBase',
  components: {
    codemirror
  },
  model: {
    prop: 'value',
    event: 'change'
  }
})], InlineCodeMirrorBase);
export { InlineCodeMirrorBase };
//# sourceMappingURL=index.js.map
